import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  Route,
  Routes,
  useLocation,
  useMatch,
  useNavigate,
} from "react-router";
import qs from "query-string";
import { createContext } from "react";
import Layout from "./components/Layout.jsx";
import NoColor from "./wrappers/NoColor.jsx";
import HomePage from "./views/HomePage.jsx";
import GameLoop from "./views/GameLoop.jsx";
import MintPage from "./views/MintPage.jsx";
import MoreInfo from "./views/MoreInfo.jsx";
import Tokenomics from "./views/Tokenomics.jsx";
import { MetaMaskWrapper } from "./wrappers/MetaMaskWrapper.jsx";
import Funds from "./views/Funds.jsx";
import MintV2Page from "./views/MintPage_v2.jsx";
import { Skins } from "./views/Skins.jsx";
import SkinMintPage from "./views/SkinMintPage.jsx";
import { HelmetProvider } from "react-helmet-async";
import Tutorial from "./views/Tutorial.jsx";
import { SkinGamePage } from "./views/SkinGamePage.jsx";
import { Skin_Xmas_Page } from "./views/Skin_Xmas.jsx";
import { useQueries } from "@tanstack/react-query";
import { q_token_prices } from "./queries/queries.jsx";
import { getv } from "./utils/utils.jsx";
import { BikeBurnPage } from "./views/BikeBurn.jsx";
import { PrizeboxPage } from "./views/PrizeboxPage.jsx";
import MintFactionAgentsPage from "./views/MintFactionAgentsPage.jsx";
import { ChainPlayPage } from "./views/ChainPlayPage.jsx";
import AccountWrapper from "./wrappers/AccountWrapper.jsx";
import { Sponsor_RAS } from "./views/Sponsor_RAS.jsx";
import { ThirdWebLoginWrapper } from "./views/ThirdWebLogin.jsx";
import { SeasonPassPage } from "./views/SeasonPassPage.jsx";
import { TP_GiftCardPage } from "./views/TP_GiftCard.jsx";
import AuthWrapper from "./wrappers/AuthWrapper.jsx";
import { PrizeboxPage as NewPrizeboxPage } from "./views/Prizebox/PrizeboxPage.jsx";
import { SeasonPass_SeasonBlast } from "./views/SeasonPass_SeasonBlast.jsx";
import { SkinsMaster } from "./views/SkinsMaster/SkinsMaster.jsx";
import TestPage from "./views/TestPage.jsx";

export const AppContext = createContext({});
export const useAppContext = () => useContext(AppContext);

export const NowContext = createContext({ now: null });
export const useNowContext = () => useContext(NowContext);

const tokdecnmap = {
  WETH: 6,
  weth: 6,
  ETH: 6,
  DEZ: 0,
  USD: 2,
  "weth-mock01": 6,
  lc01: 6,
  lc02: 2,
  lc: 3,
  LC: 3,
};

export const tokdecn = (token) => tokdecnmap[token] ?? 2;
const tokedecn2map = {
  WETH: 3,
  weth: 3,
  ETH: 3,
  DEZ: 0,
  USD: 2,
  "weth-mock01": 3,
  lc01: 3,
  lc02: 2,
  lc: 2,
  LC: 2,
};
export const tokdecn2 = (token) => tokedecn2map[token] ?? 2;

function App() {
  const history = useNavigate();
  const location = useLocation();
  const psearch = qs.parse(location.search);

  const upd_psearch = (upd) => {
    let se = qs.stringify({ ...psearch, ...upd }, { arrayFormat: "bracket" });
    history(`${location.pathname}?${se}`);
  };

  const [now, set_now] = useState(Date.now());
  useEffect(() => {
    setTimeout(() => set_now(Date.now()), 200);
  }, [now]);

  const [qo_tokpri] = useQueries({ queries: [q_token_prices()] });
  const tokmap = useMemo(
    () => getv(qo_tokpri, "data.result") || { ethusd: 0, dezusd: 0 },
    [qo_tokpri.dataUpdatedAt],
  );

  const tokkey = (c) => (c == "WETH" ? "ethusd" : c == "DEZ" ? "dezusd" : null);
  const tok_to_usd_val = (cost, token) => {
    let k = tokkey(token);
    if (!k) return null;
    let tokp = tokmap[k];
    return parseFloat(tokp) * parseFloat(cost);
  };
  const usd_to_tok_val = (cost, token) => {
    let k = tokkey(token);
    if (!k) return null;
    let tokp = tokmap[k];
    return parseFloat(cost) / parseFloat(tokp);
  };

  const appcon = {
    history,
    location,
    path: location.pathname,
    psearch,
    upd_psearch,

    tokmap,
    tok_to_usd_val,
    usd_to_tok_val,
  };

  return (
    <div className="App bg-dark text-white">
      <NowContext.Provider value={{ now }}>
        <AppContext.Provider value={appcon}>
          <MetaMaskWrapper>
            <ThirdWebLoginWrapper>
              <AuthWrapper>
                <AccountWrapper>
                  <Layout>
                    <HelmetProvider>
                      <Routes>
                        <Route path="/gameloop" exact element={<GameLoop />} />
                        <Route path="/mint" exact element={<MintPage />} />
                        <Route path="/mint_v2" exact element={<MintV2Page />} />
                        <Route
                          path="/factions"
                          exact
                          element={<MintFactionAgentsPage />}
                        />
                        <Route
                          path="/bikeburn"
                          exact
                          element={<BikeBurnPage />}
                        />
                        <Route
                          path="/old-prizebox"
                          exact
                          element={<PrizeboxPage />}
                        />
                        <Route
                          path="/prizebox"
                          exact
                          element={<NewPrizeboxPage />}
                        />

                        <Route
                          path="/tp_giftcard"
                          exact
                          element={<TP_GiftCardPage />}
                        />

                        <Route path="/legacy-skins" exact element={<Skins />} />
                        <Route path="/skins" exact element={<SkinsMaster />} />
                        <Route
                          path="/skinmint"
                          exact
                          element={<SkinMintPage />}
                        />
                        <Route
                          path="/skingame"
                          exact
                          element={<SkinGamePage />}
                        />
                        <Route
                          path="/skin-xmas"
                          exact
                          element={<Skin_Xmas_Page />}
                        />

                        <Route
                          path="/seasonpass/seasonblast"
                          exact
                          element={<SeasonPass_SeasonBlast />}
                        />

                        <Route
                          path="/seasonpass"
                          exact
                          element={<SeasonPassPage />}
                        />

                        <Route path="/moreinfo" exact element={<MoreInfo />} />
                        <Route
                          path="/tokenomics"
                          exact
                          element={<Tokenomics />}
                        />
                        <Route path="/funds" exact element={<Funds />} />
                        <Route path="/tutorial" exact element={<Tutorial />} />
                        {/*                         <Route path="/test" exact element={<TestPage />} /> */}
                        <Route path="/" exact element={<HomePage />} />
                      </Routes>
                    </HelmetProvider>
                  </Layout>
                  <NoColor />
                </AccountWrapper>
              </AuthWrapper>
            </ThirdWebLoginWrapper>
          </MetaMaskWrapper>
        </AppContext.Provider>
      </NowContext.Provider>
    </div>
  );
}

export default App;
